import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { Config } from './config'

/**
 * Adapts one entity collection into canonical table configuration snapshots.
 *
 * The plugin owns only normalized, collection-specific configuration. Runtime
 * entity state remains in the standard collection plugins and is read by the
 * separate signal mapper.
 */
export class Plugin<
  TTypeParams extends ec.models.TypeParams.Constraint,
> extends ec.plugins.Plugin<
  TTypeParams,
  typeof Plugin.id,
  Record<string, never>,
  Record<string, never>,
  Record<string, never>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static readonly id = ec.plugins.Plugin.Id.Custom.create('DsTable')

  /** Collection-owned adapter configuration shared by all table views. */
  public readonly config: Config<TTypeParams>

  constructor({ collection, config }: Plugin.constructor.Params<TTypeParams>) {
    // Normalize once at plugin construction so every mapper invocation sees
    // the same defaults and no snapshot has to repeat option merging.
    const finalConfig = Config.from(config)
    super({
      actions: {},
      collection,
      id: Plugin.id,
      initialState: {},
      selectors: () => ({}),
    })
    this.config = finalConfig
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params<
      TTypeParams extends ec.models.TypeParams.Constraint,
    > {
      readonly collection: ec.Collection<TTypeParams>
      readonly config?: Config.Options<TTypeParams>
    }
  }
}
